import styled from 'styled-components';

export const Container = styled.div`
  .ant-table-column-title {
    color: #1890ff;
    text-transform: capitalize;
  }
`;
